<script setup lang="ts">
import {onMounted, watch} from 'vue';
import {storeToRefs} from 'pinia';
import {useCrmAccountStore, useValueDataStore} from '@/stores';
import {businessDevelopmentFields} from '@/crm/spec/businessDevelopmentFields';
import FieldSection from '@/crm/components/FieldSection.vue';
import Spinner from '@/components/common/Spinner.vue';

const valueStore = useValueDataStore();
const crmStore = useCrmAccountStore();
const {selectionId} = storeToRefs(valueStore);
const {account, isAccountLoading, accountError} = storeToRefs(crmStore);

async function load() {
    await crmStore.ensureAccount();
}

onMounted(load);
watch(selectionId, load);
</script>

<template>
    <div class="crm-page">
        <div v-if="!selectionId" class="placeholder">Select a store or group to view its CRM record.</div>

        <template v-else>
            <div v-if="isAccountLoading && !account" class="loading"><Spinner/></div>
            <div v-else-if="accountError" class="error">Couldn't load account.</div>

            <template v-else-if="account">
                <FieldSection
                    v-for="(s, i) in businessDevelopmentFields.sections"
                    :key="i"
                    :section="s"
                    :record="account"
                />
            </template>
        </template>
    </div>
</template>

<style scoped>
.crm-page {
    padding: 1.5rem;
    max-width: 1400px;
    margin: 0 auto;
    color: var(--color-text);
}

.placeholder, .error {
    padding: 2rem;
    text-align: center;
    opacity: 0.7;
    font-size: var(--font-size-body);
}

.loading {
    display: flex;
    justify-content: center;
    padding: 3rem;
}
</style>
